import React from 'react';
import { BiSolidReport } from "react-icons/bi";
import { IoDocuments } from "react-icons/io5";
import { PiFolderSimpleUserBold } from "react-icons/pi";
import { NavLink } from 'react-router-dom'; // Import NavLink
import './layout.css'; // Make sure this path is correct
import { IoDocumentSharp } from "react-icons/io5";

const WorkReportLayout = ({ children }) => {

  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <BiSolidReport  className="leave-policy-icon" />
        Employee Work Report
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="today-report-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/today-report"
              >
                <IoDocumentSharp  className="nav-icon" /> Current Date
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="current-month-work-report-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/current-month-work-report"
              >
                <IoDocuments  className="nav-icon" /> Current Month Report
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="all-work-reports-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/all-work-reports"
              >
                <PiFolderSimpleUserBold  className="nav-icon" /> Employee Work Report
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default WorkReportLayout;
